import { render, staticRenderFns } from "./PermissionDeniedModal.vue?vue&type=template&id=11f869de"
import script from "./PermissionDeniedModal.vue?vue&type=script&lang=js"
export * from "./PermissionDeniedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports